module.exports = "//static.hsappstatic.net/UserPreferencesUI/static-1.24451/images/unplug.svg"